var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs mb-1 block",attrs:{"id":("label-" + _vm.forId),"data-test":"filter-label","for":_vm.forId}},[_vm._v("\n"+_vm._s(_vm.label)+"\n"),(_vm.tooltip)?_c('BaseIcon',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    content: _vm.tooltip,
    boundariesElement: 'body',
  }),expression:"{\n    content: tooltip,\n    boundariesElement: 'body',\n  }",modifiers:{"top":true}}],staticClass:"ml-2",attrs:{"icon":'info-circle'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }